import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/commerce/Setup.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/v2/setup`;
	}
	post(e) {
		return this.api.post(this.buildPath(n.baseUrl), { trackingId: e });
	}
};
//#endregion
export { n as Setup };

//# sourceMappingURL=Setup.js.map